import React, { useEffect } from 'react';
import clsx from 'clsx'
import Card from '@mui/material/Card';
import { Avatar, Typography, CardContent, Grid } from '@mui/material'
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { dashboardAction } from '_actions'
import { makeStyles } from '@mui/styles'
import { styled } from '@mui/material/styles';
import theme from './../../../../theme'

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    marginLeft: 10,
    marginRight: 10,
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  title: {
    fontWeight: 500,
    color: '#FFF'
  }
}));

const CustomAvatar = styled(Avatar)({
  height: 45,
  width: 45,
  backgroundColor: '#FFC107',
  [theme.breakpoints.down('md')]: {
    height: 35,
    width: 35,
    display: 'flex'
  },
})

const CardEmpresasPendentes = (props) => {
  const { className, ...rest } = props
  const classes = useStyles();
  const dispatch = useDispatch();

  const empresasPendentes = useSelector((state) => (state.dashboard ? state.dashboard.dashboard.empresasPendentes : undefined))

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent sx={{
        backgroundColor: '#25261C'
      }}>
        <Grid container justifyContent="space-between">
          <Grid item styles={{ display: 'flex', flexDirection: 'column' }}>
            <Grid item>
              <Typography variant="h5" className={classes.title}>
                {empresasPendentes ? empresasPendentes : 0}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="caption" gutterBottom>
                Empresas aguardando aprovação
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <CustomAvatar>
              <WorkOutlineOutlinedIcon sx={{ fontSize: 25, color: '#000' }} />
            </CustomAvatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card >
  );
}

CardEmpresasPendentes.propTypes = {
  className: PropTypes.string,
  subtitle: PropTypes.string
}

export default CardEmpresasPendentes
